import "core-js/modules/es6.regexp.constructor";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.array.find";
import _toConsumableArray from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import pick from 'lodash.pick';
import moment from 'moment';
import Vue from 'vue'; // 引入搜索部门弹出框的组件

import { ACCESS_TOKEN } from '@/store/mutation-types';
import { getAction } from '@/api/manage';
import { editUserParam, queryUserRole, queryall, queryIdTree, getUserList } from '@/api/api';
import { disabledAuthFilter } from '@/utils/authFilter';
import { duplicateCheck } from '@/api/api';
import MapGetPoint from '@/components/Map/MapGetPoint';
export default {
  name: 'RoleModal',
  components: {
    MapGetPoint: MapGetPoint
  },
  data: function data() {
    return {
      modalWidth: 800,
      drawerWidth: 700,
      modaltoggleFlag: true,
      confirmDirty: false,
      userId: '',
      //保存用户id
      disableSubmit: false,
      dateFormat: 'YYYY-MM-DD',
      paramList: [],
      mapCenter: [],
      validatorRules: {
        username: {
          rules: [{
            required: true,
            message: '请输入用户账号!'
          }, {
            validator: this.validateUsername
          }]
        },
        realname: {
          rules: [{
            required: true,
            message: '请输入用户名称!'
          }]
        },
        phone: {
          rules: [{
            validator: this.validatePhone
          }]
        },
        email: {
          rules: [{
            validator: this.validateEmail
          }]
        }
      },
      title: '个人设置',
      visible: false,
      model: {},
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 8
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 16
        }
      },
      labelCol1: {
        xs: {
          span: 24
        },
        sm: {
          span: 5
        }
      },
      wrapperCol1: {
        xs: {
          span: 24
        },
        sm: {
          span: 16
        }
      },
      uploadLoading: false,
      confirmLoading: false,
      headers: {},
      form: this.$form.createForm(this),
      picUrl: '',
      url: {
        fileUpload: window._CONFIG['domianURL'] + '/sys/common/file/upload',
        imgerver: window._CONFIG['domianURL'] + '/sys/common/file/view',
        config: '/sys/config/find/',
        userParams: '/sys/param/find/',
        userId: '/sys/user/generateUserId',
        // 引入生成添加用户情况下的url
        syncUserByUserName: '/process/extActProcess/doSyncUserByUserName' //同步用户到工作流

      }
    };
  },
  created: function created() {
    var token = Vue.ls.get(ACCESS_TOKEN);
    this.headers = {
      'X-Access-Token': token
    };
  },
  computed: {
    uploadAction: function uploadAction() {
      return this.url.fileUpload;
    }
  },
  methods: {
    bgChange: function bgChange(val) {
      this.$store.commit('changeBg', val);
      localStorage.setItem('bgLight', val);
    },
    isDisabledAuth: function isDisabledAuth(code) {
      return disabledAuthFilter(code);
    },
    //窗口最大化切换
    toggleScreen: function toggleScreen() {
      if (this.modaltoggleFlag) {
        this.modalWidth = window.innerWidth;
      } else {
        this.modalWidth = 800;
      }

      this.modaltoggleFlag = !this.modaltoggleFlag;
    },
    longitudeChange: function longitudeChange() {
      this.$refs.mapForm.show(this.mapCenter);
    },
    coordinateOk: function coordinateOk(value) {
      if (value != null) {
        var newData = _toConsumableArray(this.paramList);

        var target = newData.find(function (item) {
          return item.code === 'center_zoom';
        });

        if (target) {
          target.val = value.toString();
          this.paramList = newData;
        }

        this.form.setFieldsValue({
          center_zoom: value.toString()
        });
      }
    },
    refresh: function refresh() {
      this.userId = '';
    },
    add: function add() {
      this.picUrl = '';
      this.refresh();
      this.edit({
        activitiSync: '1'
      });
    },
    edit: function edit(record) {
      this.resetScreenSize(); // 调用此方法,根据屏幕宽度自适应调整抽屉的宽度

      this.userId = record.id;
      this.mapCenter = [];
      var that = this;
      that.visible = true;
      that.form.resetFields();

      if (record.hasOwnProperty('id')) {
        this.picUrl = 'Has no pic url yet';
      }

      this.loadUser(); //获取额外需要添加的字段信息

      this.loadParams();
    },
    loadUser: function loadUser() {
      var _this = this;

      getUserList({
        id: this.userId
      }).then(function (res) {
        if (res.success) {
          _this.model = res.result.records[0];
          var that = _this;
          that.$nextTick(function () {
            that.form.setFieldsValue(pick(_this.model, 'username', 'sex', 'realname', 'email', 'phone', 'activitiSync'));
          });
        }
      });
    },
    close: function close() {
      this.$emit('close');
      this.visible = false;
      this.disableSubmit = false;
    },
    moment: moment,
    handleSubmit: function handleSubmit() {
      var _this2 = this;

      var that = this; // 触发表单验证

      this.form.validateFields(function (err, values) {
        if (!err) {
          that.confirmLoading = true;
          var avatar = that.model.avatar; // if (!values.birthday) {
          //   values.birthday = ''
          // } else {
          //   values.birthday = values.birthday.format(this.dateFormat)
          // }

          var formData = Object.assign(_this2.model, values);
          formData.params = _this2.paramList;
          formData.avatar = avatar;
          editUserParam(formData).then(function (res) {
            if (res.success) {
              that.$notification.success({
                message: res.message
              });
              that.$emit('ok');
            } else {
              that.$notification.warning({
                message: res.message
              });
            }
          }).finally(function () {
            that.confirmLoading = false;
          });
        }
      });
    },
    handleCancel: function handleCancel() {
      this.close();
    },
    loadParams: function loadParams() {
      var _this3 = this;

      var pa = 'user_common_params';
      getAction(this.url.config + pa).then(function (res) {
        var paramList = JSON.parse(res.result);
        getAction(_this3.url.userParams + _this3.userId).then(function (res) {
          if (res.success) {
            var paramValue = res.result;
            paramList.forEach(function (element) {
              var param = paramValue.find(function (item) {
                return item.code === element.code;
              });
              element.val = param == undefined ? '' : param.val;

              if (element.code == 'center_zoom') {
                _this3.mapCenter = element.val == undefined ? [] : element.val.split(',');
              }
            });
            _this3.paramList = paramList;
          }
        });
      });
    },
    validatePhone: function validatePhone(rule, value, callback) {
      if (!value) {
        callback();
      } else {
        if (new RegExp(/^1[3|4|5|7|8][0-9]\d{8}$/).test(value)) {
          var params = {
            tableName: 'sys_user',
            fieldName: 'phone',
            fieldVal: value,
            dataId: this.userId
          };
          duplicateCheck(params).then(function (res) {
            if (res.success) {
              callback();
            } else {
              callback('手机号已存在!');
            }
          });
        } else {
          callback('请输入正确格式的手机号码!');
        }
      }
    },
    validateEmail: function validateEmail(rule, value, callback) {
      if (!value) {
        callback();
      } else {
        if (new RegExp(/^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/).test(value)) {
          var params = {
            tableName: 'sys_user',
            fieldName: 'email',
            fieldVal: value,
            dataId: this.userId
          };
          duplicateCheck(params).then(function (res) {
            if (res.success) {
              callback();
            } else {
              callback('邮箱已存在!');
            }
          });
        } else {
          callback('请输入正确格式的邮箱!');
        }
      }
    },
    validateUsername: function validateUsername(rule, value, callback) {
      var params = {
        tableName: 'sys_user',
        fieldName: 'username',
        fieldVal: value,
        dataId: this.userId
      };
      duplicateCheck(params).then(function (res) {
        if (res.success) {
          callback();
        } else {
          callback('用户名已存在!');
        }
      });
    },
    handleConfirmBlur: function handleConfirmBlur(e) {
      var value = e.target.value;
      this.confirmDirty = this.confirmDirty || !!value;
    },
    normFile: function normFile(e) {
      if (Array.isArray(e)) {
        return e;
      }

      return e && e.fileList;
    },
    beforeUpload: function beforeUpload(file) {
      var fileType = file.type;

      if (fileType.indexOf('image') < 0) {
        this.$message.warning('请上传图片');
        return false;
      } //TODO 验证文件大小

    },
    handleChange: function handleChange(info) {
      this.picUrl = '';

      if (info.file.status === 'uploading') {
        this.uploadLoading = true;
        return;
      }

      if (info.file.status === 'done') {
        var response = info.file.response;
        this.uploadLoading = false;

        if (response.success) {
          this.model.avatar = response.result.id;
          this.picUrl = 'Has no pic url yet';
        } else {
          this.$notification.warning({
            message: response.message
          });
        }
      }
    },
    getAvatarView: function getAvatarView() {
      return this.url.imgerver + '/' + this.model.avatar;
    },
    // 根据屏幕变化,设置抽屉尺寸
    resetScreenSize: function resetScreenSize() {
      var screenWidth = document.body.clientWidth;

      if (screenWidth < 500) {
        this.drawerWidth = screenWidth;
      } else {
        this.drawerWidth = 700;
      }
    }
  }
};